import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgErrorPayment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "Error",
		clipPath: "url(#clip0_error_payment)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M20 0C31.0279 0 39.9998 8.97157 40 19.999C40 31.0273 31.0281 40 20 40C8.97185 39.9998 0 31.0272 0 19.999C0.000240021 8.97168 8.972 0.00017456 20 0ZM20 3.21094C10.7427 3.21111 3.21118 10.7421 3.21094 19.999C3.21094 29.2567 10.7425 36.7889 20 36.7891C29.2574 36.7891 36.7891 29.2568 36.7891 19.999C36.7888 10.742 29.2573 3.21094 20 3.21094ZM25.042 12.5996C25.6936 11.9482 26.7468 11.9483 27.3984 12.5996C28.0501 13.2513 28.0501 14.3054 27.3984 14.957L22.3271 20.0283L27.3984 25.0996C28.0501 25.7513 28.0501 26.8054 27.3984 27.457C27.0736 27.7817 26.6471 27.9452 26.2207 27.9453C25.7941 27.9453 25.367 27.7819 25.042 27.457L19.9707 22.3848L14.8984 27.457C14.5736 27.7817 14.1471 27.9452 13.7207 27.9453C13.2941 27.9453 12.867 27.7819 12.542 27.457C11.8903 26.8054 11.8903 25.7513 12.542 25.0996L17.6133 20.0283L12.542 14.957C11.8903 14.3054 11.8903 13.2513 12.542 12.5996C13.1936 11.9482 14.2468 11.9483 14.8984 12.5996L19.9707 17.6719L25.042 12.5996Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_error_payment",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "white"
		})
	}) })]
});
export default SvgErrorPayment;
